import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';

import * as actions from './investmentSymbolsActions';
import { INVESTMENT_SYMBOLS_KEY as KEY } from './investmentSymbolsTypes';

const investmentSymbolsReducer = handleActions(
  {
    [actions.getInvestmentSymbols]: (state) => state.merge({ isLoading: true }),
    [actions.getInvestmentSymbolsSuccess]: (state, action) =>
      resourceUpserters.upsertResources(state, action.payload.set('replaceCollection', false)),
    [actions.getInvestmentSymbolsFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const INVESTMENT_SYMBOLS_KEY = KEY;
export default investmentSymbolsReducer;
